import { render } from "./HistoryExams.vue?vue&type=template&id=5d1d89e6"
import script from "./HistoryExams.vue?vue&type=script&lang=js"
export * from "./HistoryExams.vue?vue&type=script&lang=js"

import exportComponent from "D:\\CTL-Project\\ChatBotSHLX\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__